import { render, staticRenderFns } from "./KnProductBrands.vue?vue&type=template&id=72729e1b"
import script from "./KnProductBrands.js?vue&type=script&lang=js&external"
export * from "./KnProductBrands.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports